import { isNil } from 'lodash'
import type { TSplineSeriesData } from '../../types'

/**
 * the differential is only meaningful where both sides of the filter
 * reported at the same stamp, so timestamps without a pair are skipped
 */
export const getPressureDifferentialData = ({
  preFilterData,
  postFilterData,
}: {
  preFilterData: TSplineSeriesData[]
  postFilterData: TSplineSeriesData[]
}): TSplineSeriesData[] => {
  if (!preFilterData.length || !postFilterData.length) return []

  const postFilterValuesByStamp = new Map(postFilterData.map((d) => [d.x, d.y]))

  return preFilterData.flatMap((preFilterPoint) => {
    const postFilterValue = postFilterValuesByStamp.get(preFilterPoint.x)

    if (isNil(preFilterPoint.y) || isNil(postFilterValue)) return []

    return [
      {
        x: preFilterPoint.x,
        y: Number((preFilterPoint.y - postFilterValue).toFixed(2)),
      },
    ]
  })
}
